import { forwardRef, type Ref, type SVGProps } from "react";
const IconZoomOutFilledSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path d="m29.41 26.59-7.35-7.36a11 11 0 1 0-2.83 2.83l7.36 7.35a2 2 0 0 0 2.82-2.82M13 20a7 7 0 1 1 7-7 7 7 0 0 1-7 7" />
    <path d="M17 12H9a1 1 0 0 0-.7 1.69A1 1 0 0 0 9 14h8a1 1 0 0 0 0-2" />
  </svg>
);
const ForwardRef = forwardRef(IconZoomOutFilledSVG);
ForwardRef.displayName = "IconZoomOutFilled";
export { ForwardRef as IconZoomOutFilled };
